import { AppButton, AppTextField } from 'components';
import useToaster from 'hooks/useToaster';
import { useState, useEffect, useCallback, useContext, useRef } from 'react';
import { UserContext } from 'context/UserContext';
import { usePdfJob } from 'context/PdfJobContext';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
// import TablePaginate from '../../components/Paginate';
import useChapters from 'hooks/API/GET/useChapters';
import useChapterAdd from 'hooks/API/POST/useChapterAdd';
import { Link, useParams } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import usePaginateDefaults from 'hooks/usePaginateDefaults';
import * as AppPics from 'assets/images';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useManageTopics from 'hooks/API/useManageTopics';
import { getRandomUid } from 'utilities/uuid.service';
import { ReactSortable } from 'react-sortablejs';
import useCloneChapter from 'hooks/API/POST/useCloneChapter';
import useCloneTopic from 'hooks/API/POST/useCloneTopic';
import useReOrderChapter from 'hooks/API/POST/useReOrderChapter';
import useReOrderTopic from 'hooks/API/POST/useReOrderTopic';
import DetailsHeader from 'components/molecules/DetailsHeader';
import useManageSubTopics from 'hooks/API/useManageSubTopics';
import useCloneSubTopic from 'hooks/API/POST/useCloneSubTopic';
import useReOrderSubTopics from 'hooks/API/POST/useReOrderSubTopics';
import { AiOutlineEye } from 'react-icons/ai';
import { MdSwapCalls, MdPermScanWifi, MdPictureAsPdf } from 'react-icons/md';
import useQueryParams from 'hooks/useQueryParams';
import CopyContentsModal from './CopyContentsModal';
import BulkAssignChapter from './BulkAssignChapter';
import { ROLES, underSeReview, underTutorReview } from 'utilities/constants';
import { LightTooltip } from 'components/Inputs/Buttons';
import { notifier } from 'components/Toaster';

import { FetchContext } from 'context/FetchContext';
import { typesetMath } from 'utilities/mathjax.service';

function MainChapters() {
  const { classID, courseID } = useParams();
  // const [params, setParams] = usePaginateDefaults();
  const [selectedChapter, handleSelectedChapter] = useState({});
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const [chapterName, handleChapterName] = useState('');
  const [status, handleStatus] = useState('active');
  const [formErrors, setFormErrors] = useState([]);
  const [chapters, setChapters] = useState([]);
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const { privateFetch } = useContext(FetchContext);
  const { key } = userInfo?.data ?? {};

  const [chapterCopyMode, setChapterCopyMode] = useState({ open: false, data: {} });
  const [bulkChapterContentAssign, setBulkChapterContentAssign] = useState({
    open: false,
    data: {},
  });

  const { mutate: reorderChapter } = useReOrderChapter({ classID, courseID });
  const { mutate: reorderTopic } = useReOrderTopic({ classID, courseID });
  const { isLoading: postingChapter, mutate, isError: postingError } = useChapterAdd();
  const _chapters = useChapters({
    enabled: true,
    courseID,
    classID,
    configs: { params: { screen: 'screen_chapter_discover', apiVersion: 1 } },
  });

  const { data, isLoading, isError } = _chapters;
  const { result = [] } = data?.data ?? {};
  const queryParams = useQueryParams();
  let toScroll = queryParams.get('chapter');
  if (!toScroll) toScroll = queryParams.get('topic');
  if (!toScroll) toScroll = queryParams.get('topic');

  function scrollToTestDiv() {
    const divElement = document.getElementById(toScroll);
    if (!divElement) return;
    if (divElement.closest('.level1')) {
      divElement.closest('.level1') &&
        divElement.closest('.level1').scrollIntoView({
          behavior: 'smooth',
          alignToTop: false,
          block: 'center',
          inline: 'nearest',
        });
      divElement.closest('.level1') && divElement.closest('.level1').classList.add('highlighter');
      return;
    }
    divElement &&
      divElement.scrollIntoView({
        behavior: 'smooth',
        alignToTop: false,
        block: 'center',
        inline: 'nearest',
      });
    divElement && divElement.classList.add('highlighter');
  }
  useEffect(() => {
    setTimeout(() => {
      scrollToTestDiv(toScroll);
    }, 1000);
  }, [result]);

  useToaster(postingChapter, { type: postingError ? 'error' : 'success' });

  useEffect(() => {
    if (result?.length > 0) {
      const _result = result.map((x) => {
        if (x.topics) {
          x.topics = x.topics?.map((z) => ({ ...z, id: getRandomUid() }));
        }
        return x;
      });
      setChapters([].concat(_result));
    }
  }, [result]);

  useEffect(() => {
    if (selectedChapter?._id) {
      if (selectedChapter?.status) handleStatus(selectedChapter?.status);
      handleChapterName(selectedChapter?.name ?? '');
    }
  }, [selectedChapter]);

  function manageChapters(data) {
    if (postingChapter) return;

    mutate(data);
    closeSModal();
  }

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
    handleSelectedChapter({});
  }

  function handleSave() {
    setFormErrors([]);

    const data = {
      name: `${chapterName}`.trim(),
      courseID,
      classID,
      status,
    };

    const validation = manageChaptersSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    manageChapters?.({
      ...data,
      chapterID: selectedChapter?._id,
      type: selectedChapter?._id ? 'UPDATE' : 'CREATE',
    });

    clearData();
  }

  function clearData() {
    setFormErrors([]);

    handleChapterName('');
    handleStatus('active');
    handleSelectedChapter({});
  }

  function handleChapterReOrder() {
    const _chapters = chapters.map((x) => x._id);
    reorderChapter({ chapters: _chapters });
  }

  function handleTopicReOrder(chapter) {
    const _selectedChapter = chapters.find((x) => x._id === chapter._id);
    const topics = _selectedChapter?.topics?.map?.((z) => z._id) || [];
    reorderTopic({ chapterID: _selectedChapter?._id, topics });
  }

  const errors = checkForErrors(formErrors);

  const { addJob } = usePdfJob();

  function queueChapterPdfExport(chapter) {
    if (!chapter) return;

    const safeChapterName = (chapter.name || 'Chapter').trim() || 'Chapter';
    const filename = getChapterPdfFilename(safeChapterName);

    addJob({
      title: `Chapter: ${safeChapterName}`,
      filename,
      downloadFn: () => downloadChapterPdf(chapter),
      run: async ({ updateJob, isCancelled, signal }) => {
        updateJob({ status: 'SENDING', progress: 10, error: '' });

        const chapterPdfPath = getChapterPdfBasePath({
          classID,
          courseID,
          chapterID: chapter._id,
        });

        const generationPayload = {
          chapterID: chapter._id,
          chapterName: safeChapterName,
          fileName: filename,
        };

        const startGeneration = async (attempt = 1) => {
          updateJob({
            status: 'SENDING',
            progress: attempt > 1 ? 25 : 15,
            error: '',
          });

          const generateResponse = await requestChapterPdfGeneration({
            privateFetch,
            chapterPdfPath,
            payload: generationPayload,
            signal,
          });
          const generateData = getResponseData(generateResponse);
          const jobId =
            generateData.jobId || generateData.job_id || generateData.currentJobId || '';

          updateJob({
            status: 'PROCESSING',
            progress: 30,
            job_id: jobId,
            error: '',
          });
        };

        let finalStatus;
        for (let attempt = 1; attempt <= 2; attempt += 1) {
          await startGeneration(attempt);
          if (isCancelled()) throw new Error('PDF job cancelled');

          try {
            finalStatus = await pollChapterPdfGeneration({
              privateFetch,
              classID,
              courseID,
              chapterID: chapter._id,
              isCancelled,
              signal,
              onProgress: (progress) => {
                updateJob({
                  status: 'PROCESSING',
                  progress: Math.min(95, 30 + progress * 0.65),
                });
              },
            });
            break;
          } catch (error) {
            if (attempt < 2 && getErrorMessage(error).toLowerCase().includes('lost')) {
              console.warn('Chapter PDF job was lost; starting a fresh generation.', error);
              continue;
            }
            throw new Error(getChapterPdfFailureMessage(error));
          }
        }

        updateJob({
          status: 'COMPLETED',
          progress: 100,
          downloaded: false,
          generatedAt: finalStatus.lastGeneratedAt || finalStatus.generatedAt || '',
        });

        notifier.success(`${safeChapterName} PDF generated and saved successfully.`);
      },
    });

    notifier.info(`Queued chapter PDF generation for ${safeChapterName}`);
  }

  async function exportLessonPdf(topicName, topicID, chapterID) {
    const safeTopicName = (topicName || 'Lesson').trim() || 'Lesson';
    const filename = `${safeTopicName.replace(/\s+/g, '_')}.pdf`;

    addJob({
      title: `Lesson: ${safeTopicName}`,
      filename,
      run: async ({ updateJob, isCancelled, signal }) => {
        updateJob({ status: 'PROCESSING', progress: 10, error: '' });

        try {
          const response = await privateFetch.post(
            getLessonPdfBasePath({ classID, courseID, chapterID, topicID }),
            { fileName: filename },
            { responseType: 'blob', signal }
          );

          if (isCancelled()) throw new Error('PDF job cancelled');

          updateJob({ progress: 95 });
          downloadPdfBlob(response.data, filename);

          updateJob({
            status: 'COMPLETED',
            progress: 100,
            downloaded: true,
          });

          notifier.success(`${safeTopicName} PDF downloaded successfully.`);
        } catch (error) {
          if (isCancelled()) throw error;
          const message = getErrorMessage(error) || 'Failed to download lesson PDF.';
          throw new Error(message);
        }
      },
    });
  }

  async function downloadChapterPdf(chapter) {
    if (!chapter) return false;

    const safeChapterName = (chapter.name || 'Chapter').trim() || 'Chapter';

    try {
      const response = await privateFetch.get(
        `${getChapterPdfBasePath({
          classID,
          courseID,
          chapterID: chapter._id,
        })}/download`,
        {
          responseType: 'blob',
        }
      );

      downloadPdfBlob(response.data, getChapterPdfFilename(safeChapterName));
      notifier.success(`${safeChapterName} PDF downloaded successfully.`);
      return true;
    } catch (error) {
      if (error?.response?.status === 404) {
        notifier.error(`No generated PDF found for ${safeChapterName}. Generate it first.`);
        return false;
      }

      notifier.error(`Failed to download PDF for ${safeChapterName}.`);
      return false;
    }
  }

  return (
    <>
      {bulkChapterContentAssign.open && (
        <BulkAssignChapter
          open={bulkChapterContentAssign.open}
          closeModal={() => {
            setBulkChapterContentAssign({ open: false, data: {} });
          }}
          data={{
            apiData: bulkChapterContentAssign.data,
            userPermissions,
          }}
        />
      )}
      {chapterCopyMode.open && (
        <CopyContentsModal
          open={chapterCopyMode.open}
          closeModal={() => {
            setChapterCopyMode({ open: false, data: {} });
          }}
          data={chapterCopyMode.data}
        />
      )}
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete Chapter"
        handleConfirmation={() => {
          manageChapters({ ...(deleteSModal.data ?? {}), classID, type: 'DELETE' });
        }}
      />
      <div className="mainWraper ___chapterListing__module___cust___clas">
        {/* <div className="saved-flag changessave">
          <span className="green-check"></span>
          Changes Saved!
        </div> */}
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <Link to={`/courses/${courseID}/edit`}>
                <AppButton variantClass="btn-back">
                  <img src={AppPics.BackSvg} alt="" />
                </AppButton>
              </Link>
            </li>
            <li className="active">Course Structure</li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <DetailsHeader />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5">
                <div className="row my-4">
                  <div className="col-12">
                    <div className="lessonWrap lessonWrap--border formfield">
                      <AppTextField
                        labelProps={{ label: 'Chapter Name' }}
                        inputProps={{
                          placeholder: userPermissions?.chapter?.canCreateNew
                            ? 'Enter chapter name here...'
                            : 'Sorry you dont have enough permission to add a chapter',
                          disabled: !userPermissions?.chapter?.canCreateNew,
                          value: chapterName,
                          onChange: (event) => handleChapterName(event.target.value),
                        }}
                        fieldErrors={errors['name']}
                      />
                      {
                        <AppButton
                          disabled={!userPermissions?.chapter?.canCreateNew}
                          variantClass="btn-plane p--tint m-l-btn my-4"
                          onClick={() =>
                            userPermissions?.chapter?.canCreateNew
                              ? handleSave()
                              : alert('You have not permitted to do this action.')
                          }
                        >
                          Add CHAPTER
                        </AppButton>
                      }
                    </div>
                  </div>
                </div>

                {isLoading ? (
                  'Loading...'
                ) : isError ? (
                  'Failed to load data'
                ) : (
                  <ReactSortable
                    list={chapters}
                    setList={setChapters}
                    handle=".chapterGrabHandleID"
                    filter="button, a, input, textarea, select, [data-no-drag='true']"
                    preventOnFilter={false}
                    onSort={userPermissions?.chapter?.canSortChapter && handleChapterReOrder}
                  >
                    {chapters.map((item) => {
                      return (
                        <div className="row mt-5 relative" key={item._id}>
                          <div className="col-12">
                            <div className="saved lessonWrap--border p-0">
                              <div className="row bgltgreen level1">
                                <div className="col-md-10 col-lg-10 col-sm-12">
                                  <div
                                    id={`${item._id}`}
                                    className="lessonWrap saved lessonWrap--border"
                                  >
                                    <ManageChapter
                                      data={{
                                        classID,
                                        courseID,
                                        __chapterCloneState: [chapterCopyMode, setChapterCopyMode],
                                        __bulkAssignChapterContent: [
                                          bulkChapterContentAssign,
                                          setBulkChapterContentAssign,
                                        ],
                                      }}
                                      chapter={item}
                                      fns={{
                                        handleDelete: (chapter) =>
                                          handleDeleteSModal({
                                            show: true,
                                            data: {
                                              courseID,
                                              classID,
                                              chapterID: chapter._id,
                                            },
                                          }),
                                      }}
                                      handleSave={(data = {}, cb) => {
                                        if (postingChapter) return;

                                        const body = {
                                          courseID,
                                          classID,
                                          status,
                                          ...data,
                                        };
                                        mutate(body, {
                                          onSuccess() {
                                            cb?.();
                                          },
                                        });
                                      }}
                                      queueChapterPdfExport={queueChapterPdfExport}
                                      downloadChapterPdf={downloadChapterPdf}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-2 col-lg-2 col-sm-12 mt-2 my-auto _pcetnteefid">
                                  <AppButton
                                    variantClass="btn-plane p--tint m-l-btn"
                                    disabled={
                                      !userPermissions?.lesson?.canAddLesson ||
                                      item.isInTeacherReview
                                    }
                                    onClick={() => {
                                      if (item.isInTeacherReview) return;

                                      if (!userPermissions?.lesson?.canAddLesson)
                                        alert(
                                          'You dont have sufficient permission to do this action.'
                                        );
                                      const _chapters = chapters.map((x) => {
                                        if (x._id === item._id) {
                                          x.topics =
                                            x.topics?.concat({
                                              id: getRandomUid(),
                                              name: '',
                                            }) ?? [];
                                        }
                                        return x;
                                      });

                                      setChapters(_chapters);
                                    }}
                                  >
                                    + LESSON
                                  </AppButton>
                                </div>
                              </div>
                              <ReactSortable
                                list={item?.topics}
                                setList={(newState) => {
                                  setChapters(
                                    chapters.map((x) => {
                                      if (item._id === x._id) {
                                        x.topics = newState;
                                      }

                                      return x;
                                    })
                                  );
                                }}
                                handle=".topicGrabHandleID"
                                onSort={() =>
                                  userPermissions?.lesson?.canSortLesson && handleTopicReOrder(item)
                                }
                              >
                                {item?.topics?.map((topic) => {
                                  return (
                                    <ManageLesson
                                      key={topic.id}
                                      data={{
                                        __chapterCloneState: [chapterCopyMode, setChapterCopyMode],
                                        __bulkAssignChapterContent: [
                                          bulkChapterContentAssign,
                                          setBulkChapterContentAssign,
                                        ],
                                      }}
                                      selectedTopic={topic}
                                      chapterID={item._id}
                                      chapter={item}
                                      queueChapterPdfExport={queueChapterPdfExport}
                                      downloadChapterPdf={downloadChapterPdf}
                                      exportLessonPdf={exportLessonPdf}
                                      sortSubLessons={(newState, topicID) => {
                                        setChapters(
                                          chapters.map((chapter) => {
                                            if (chapter._id === item._id) {
                                              chapter.topics = (chapter.topics || []).map((t) => {
                                                if (t._id === topicID) {
                                                  t.subTopics = newState;
                                                }
                                                return t;
                                              });
                                            }
                                            return chapter;
                                          })
                                        );
                                      }}
                                    />
                                  );
                                })}
                              </ReactSortable>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </ReactSortable>
                )}
              </div>
            </div>

            {/* <TablePaginate
              maxCount={total}
              currentPage={page}
              defaultLimit={params.limit}
              setPage={(page) => setParams((x) => ({ ...x, page }))}
              handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
            /> */}
          </div>
        </div>
      </div>
      {/* PDF Global Tracker is handled in App.js */}
    </>
  );
}

const manageChaptersSchema = Joi.object({
  name: Joi.string().required().trim(),
  status: Joi.string().required(),
});

const CHAPTER_PDF_STATUS_POLL_MS = 2000;
const CHAPTER_PDF_POLL_TIMEOUT_MS =
  Number(process.env.REACT_APP_CHAPTER_PDF_POLL_TIMEOUT_MS) || 45 * 60 * 1000;

const getResponseData = (response = {}) => response?.data?.data || response?.data || {};

const getChapterPdfFilename = (chapterName = 'Chapter') =>
  `${chapterName.replace(/\s+/g, '_')}_FULL.pdf`;

const getChapterPdfBasePath = ({ classID, courseID, chapterID }) =>
  `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/pdf`;

const getLessonPdfBasePath = ({ classID, courseID, chapterID, topicID }) =>
  `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/pdf`;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getErrorMessage = (error = {}) => {
  if (typeof error === 'string') return error;
  const responseData = getResponseData(error?.response);
  return (
    responseData?.error ||
    responseData?.message ||
    error?.error ||
    error?.message ||
    String(error || '')
  );
};

const getChapterPdfFailureMessage = (error = {}) =>
  getErrorMessage(error) || 'Chapter PDF generation failed. Please try again.';

function downloadPdfBlob(blobData, filename) {
  const blob =
    blobData instanceof Blob ? blobData : new Blob([blobData], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 5000);
}

async function requestChapterPdfGeneration({ privateFetch, chapterPdfPath, payload, signal }) {
  try {
    return await privateFetch.patch(chapterPdfPath, payload, { signal });
  } catch (error) {
    const status = error?.response?.status;
    if ([404, 405].includes(status)) {
      return privateFetch.post(chapterPdfPath, payload, { signal });
    }
    throw error;
  }
}

async function getChapterPdfStatus({ privateFetch, classID, courseID, chapterID, signal }) {
  try {
    const response = await privateFetch.get(
      `${getChapterPdfBasePath({ classID, courseID, chapterID })}/status`,
      { signal }
    );
    const statusData = getResponseData(response);
    return {
      ...statusData,
      hasPdf: Boolean(statusData?.hasPdf || statusData?.exists || statusData?.generatedAt),
    };
  } catch (error) {
    if (error?.response?.status === 404) {
      return { hasPdf: false, status: 'not_found', progress: 0 };
    }
    throw error;
  }
}

async function pollChapterPdfGeneration({
  privateFetch,
  classID,
  courseID,
  chapterID,
  onProgress = () => {},
  isCancelled = () => false,
  signal,
}) {
  const pollStartedAt = Date.now();

  while (true) {
    if (isCancelled()) throw new Error('PDF job cancelled');
    if (Date.now() - pollStartedAt > CHAPTER_PDF_POLL_TIMEOUT_MS) {
      throw new Error(
        'Chapter PDF generation timed out. The server may still be processing; try Download PDF later.'
      );
    }

    await wait(CHAPTER_PDF_STATUS_POLL_MS);
    if (isCancelled()) throw new Error('PDF job cancelled');

    const statusData = await getChapterPdfStatus({
      privateFetch,
      classID,
      courseID,
      chapterID,
      signal,
    });

    const normalizedStatus = String(statusData?.status || '').toLowerCase();
    const progress = Number(statusData?.progress || 0);
    onProgress(progress);

    if (normalizedStatus === 'completed') return statusData;
    if (normalizedStatus === 'failed' || normalizedStatus === 'not_found') {
      throw new Error(getChapterPdfFailureMessage(statusData));
    }
  }
}

function ManageChapter({
  chapter,
  handleSave,
  fns = {},
  data = {},
  queueChapterPdfExport = () => {},
  downloadChapterPdf = () => {},
}) {
  const { userPermissions = {} } = useContext(UserContext);
  const { classID, __chapterCloneState = [], __bulkAssignChapterContent = [], courseID } = data;
  const { handleDelete } = fns;
  const [editMode, setEditMode] = useState(false);
  const [chapterCopyMode, setChapterCopyMode] = __chapterCloneState;
  const [bulkChapterContentAssign, setBulkChapterContentAssign] = __bulkAssignChapterContent;
  const [chapterName, setChapterName] = useState('');
  const [pdfMenuAnchorEl, setPdfMenuAnchorEl] = useState(null);
  const chapterNameRef = useRef(null);

  const { mutate, isLoading, isError } = useCloneChapter({ classID });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  useEffect(() => {
    setChapterName(chapter.name || '');
  }, [chapter.name]);

  useEffect(() => {
    if (!editMode) typesetMath(chapterNameRef.current);
  }, [chapter.name, editMode]);

  function save(body = {}, cb) {
    if (!chapterName) {
      setChapterName(chapter.name || '');
      setEditMode(!editMode);
      return;
    }

    handleSave(
      {
        type: 'UPDATE',
        name: `${chapterName}`.trim(),
        chapterID: chapter._id,
        key: chapter.key,
        ...body,
      },
      cb
    );
    // setEditMode(!editMode);
    setEditMode(false);
  }

  function cloneChapter() {
    if (isLoading) return;
    if (!chapter._id) return;

    const data = { chapters: [chapter._id] };
    mutate(data);
  }

  function openPdfMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setPdfMenuAnchorEl(event.currentTarget);
  }

  function closePdfMenu() {
    setPdfMenuAnchorEl(null);
  }

  return (
    <>
      <div className="lessonWrap__text">
        <div
          className={userPermissions?.chapter?.canSortChapter ? 'chapterGrabHandleID' : '___noDrag'}
          style={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flex: 1,
            flexShrink: 1,
            cursor: userPermissions?.chapter?.canSortChapter ? 'grab' : 'default',
          }}
        >
          {!editMode && (
            <span className="lessonWrap__name" ref={chapterNameRef}>
              {chapter.name}{' '}
            </span>
          )}
          {editMode && (
            <input
              type="text"
              value={chapterName}
              disabled={!userPermissions?.chapter?.canEditInfo}
              onChange={(event) => {
                if (chapter.isInTeacherReview) return;

                userPermissions?.chapter?.canEditInfo && setChapterName(event.target.value);
              }}
            />
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
          {!editMode && (
            <AppButton
              variantClass="lessonWrap__btn"
              disabled={!userPermissions?.chapter?.canEditInfo || chapter.isInTeacherReview}
              onClick={() => {
                if (chapter.isInTeacherReview) return;

                userPermissions?.chapter?.canEditInfo && setEditMode(!editMode);
              }}
              title="Edit"
            >
              <img src={AppPics.EditSvg} alt="" />
            </AppButton>
          )}
          {editMode && (
            <AppButton
              disabled={!userPermissions?.chapter?.canEditInfo || chapter.isInTeacherReview}
              variantClass="lessonWrap__btn"
              onClick={() => {
                if (chapter.isInTeacherReview) return;

                userPermissions?.chapter?.canEditInfo && save();
              }}
              title="Save"
            >
              <img src={AppPics.CheckSvg} alt="" />
            </AppButton>
          )}
          {true && (
            <AppButton
              variantClass="lessonWrap__btn"
              title="Copy"
              disabled={chapter.isInTeacherReview}
              onClick={() => {
                if (chapter.isInTeacherReview) return;

                setChapterCopyMode({
                  open: true,
                  data: { chapterID: chapter._id, classID, isCopy: true },
                });
              }}
            >
              <img src={AppPics.CopySvg} alt="" />
            </AppButton>
          )}
          {true && (
            <AppButton
              variantClass="lessonWrap__btn"
              title="Bulk Assign"
              onClick={() => {
                setBulkChapterContentAssign({
                  open: true,
                  data: { chapterID: chapter._id, classID, courseID },
                });
              }}
            >
              <MdSwapCalls color="#7e1f8c" fontSize={'22px'} style={{ verticalAlign: 'middle' }} />
            </AppButton>
          )}

          <AppButton
            variantClass="lessonWrap__btn"
            title="Clone"
            disabled={!userPermissions?.chapter?.canDuplicateChapter || chapter.isInTeacherReview}
            onClick={() => {
              if (chapter.isInTeacherReview) return;

              userPermissions?.chapter?.canDuplicateChapter && cloneChapter({ isCopy: false });
            }}
          >
            <img src={AppPics.StampSvg} alt="Clone" />
          </AppButton>
          {chapter.status === 'hide' && (
            <AppButton
              variantClass="lessonWrap__btn"
              disabled={!userPermissions?.chapter?.canHideChapter || chapter.isInTeacherReview}
              onClick={() => {
                if (chapter.isInTeacherReview) return;

                if (userPermissions?.chapter?.canHideChapter) {
                  save({ status: 'active' });
                }
              }}
            >
              <img src={AppPics.ViewStrikeSvg} alt="Hide/View chapter" />
            </AppButton>
          )}
          {chapter.status === 'active' && (
            <AppButton
              variantClass="lessonWrap__btn"
              disabled={!userPermissions?.chapter?.canHideChapter || chapter.isInTeacherReview}
              onClick={() => {
                if (chapter.isInTeacherReview) return;

                if (userPermissions?.chapter?.canHideChapter) {
                  save({ status: 'hide' });
                }
              }}
            >
              <AiOutlineEye
                style={{ color: '#7e1f8c', fontSize: '22px', verticalAlign: 'middle' }}
              />
            </AppButton>
          )}

          <AppButton
            variantClass="lessonWrap__btn"
            disabled={!userPermissions?.chapter?.canDeleteChapter || chapter.isInTeacherReview}
            onClick={() => {
              if (chapter.isInTeacherReview) return;

              userPermissions?.chapter?.canDeleteChapter && handleDelete(chapter);
            }}
            title="Delete"
          >
            <img src={AppPics.TrashBinSvg} alt="" />
          </AppButton>

          <AppButton
            variantClass="lessonWrap__btn"
            title="Chapter PDF"
            data-no-drag="true"
            onPointerDownCapture={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            onMouseDownCapture={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            onMouseDown={(event) => event.stopPropagation()}
            onTouchStart={(event) => event.stopPropagation()}
            onClick={openPdfMenu}
          >
            <MdPictureAsPdf
              style={{
                color: '#7e1f8c',
                fontSize: '22px',
                verticalAlign: 'middle',
              }}
            />
          </AppButton>
          <Menu
            anchorEl={pdfMenuAnchorEl}
            open={Boolean(pdfMenuAnchorEl)}
            onClose={closePdfMenu}
            MenuListProps={{
              onClick: (event) => {
                event.stopPropagation();
              },
            }}
          >
            <MenuItem
              onClick={() => {
                closePdfMenu();
                queueChapterPdfExport(chapter);
              }}
            >
              Generate PDF
            </MenuItem>
            <MenuItem
              onClick={() => {
                closePdfMenu();
                downloadChapterPdf(chapter);
              }}
            >
              Download PDF
            </MenuItem>
          </Menu>
        </div>
      </div>
    </>
  );
}

function ManageLesson({
  chapter,
  chapterID,
  selectedTopic = {},
  sortSubLessons,
  data = {},
  queueChapterPdfExport = () => {},
  downloadChapterPdf = () => {},
  exportLessonPdf = () => {},
}) {
  const { _id: topicID, name: usedTopicName, subTopics = [] } = selectedTopic;
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const { privateFetch } = useContext(FetchContext);
  const { classID, courseID } = useParams();
  const [topicName, setTopicName] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const { __chapterCloneState = [] } = data;
  const [chapterCopyMode, setChapterCopyMode] = __chapterCloneState;

  const [subTopicName, setSubTopicName] = useState('');
  const [addSubTopicView, setAddSubTopicView] = useState(false);
  const { addJob } = usePdfJob();
  const [lessonPdfAnchorEl, setLessonPdfAnchorEl] = useState(null);
  const topicNameRef = useRef(null);

  const { mutate, isLoading, isError } = useManageTopics({ classID, courseID, chapterID });
  const { mutate: clone, isLoading: loading, isError: err } = useCloneTopic({ classID, chapterID });

  const _subtopics = useManageSubTopics({ classID, courseID, chapterID, topicID });
  const { mutate: createSubTopic, isLoading: isUpdating } = _subtopics;
  const _reOrder = useReOrderSubTopics({ classID, courseID, chapterID, topicID });
  const { mutate: reOrder, isLoading: reordering } = _reOrder;

  const cb = useCallback(
    function toasterConfig() {
      if (loading) return [loading, { type: err ? 'error' : 'success' }];
      if (isLoading) return [isLoading, { type: isError ? 'error' : 'success' }];
      return [];
    },
    [err, isError, isLoading, loading]
  );

  useToaster(...cb());

  useEffect(() => {
    if (usedTopicName) setTopicName(usedTopicName);
  }, [usedTopicName]);

  useEffect(() => {
    if (!editMode) typesetMath(topicNameRef.current);
  }, [topicName, editMode]);

  function manageTopic() {
    if (chapter.isInTeacherReview) return;

    if (!topicName) return;
    if (isLoading) return;

    const data = { name: `${topicName}`.trim(), topicID };
    if (topicID) data.type = 'UPDATE';
    mutate(data);
  }

  function manageSubTopic() {
    if (!subTopicName) return;
    if (isUpdating) return;

    const data = { name: `${subTopicName}`.trim() };
    createSubTopic(data);
  }

  function handleClone() {
    if (chapter.isInTeacherReview) return;

    if (!topicName) return;
    if (!topicID) return;
    if (loading) return;

    const data = { topics: [topicID] };

    clone(data);
  }

  function deleteTopic(topicId) {
    if (isLoading) return;

    mutate({ type: 'DELETE', topicID: topicId });
  }

  function handleSubTopicSort() {
    if (reordering) return;

    reOrder({ subTopics: subTopics.map((x) => `${x._id}`) });
  }

  // if (chapter.isInTeacherReview) return;

  const { key } = userInfo?.data ?? {};
  const isSE = key === ROLES.SUBJECT_EXPERT;
  const notTeacher = key !== ROLES.TUTOR;
  const isTeacher = key === ROLES.TUTOR;
  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={() => handleDeleteSModal({ show: false, data: {} })}
        Header="Delete Lesson"
        Body="Do you want to delete this Lesson?"
        handleConfirmation={() => {
          deleteTopic(deleteSModal?.data?._id);
          handleDeleteSModal({ show: false, data: {} });
        }}
      />
      <div className="row m-4" id={`${topicID}`}>
        <div className="col-md-10 col-lg-10 col-sm-12">
          <div
            className={`lesson_level lessonWrap lessonWrap--border ${
              userPermissions?.lesson?.canSortLesson ? 'topicGrabHandleID' : '___noDrag'
            }`}
          >
            {topicID && (
              <div className="lessonWrap__text __lesson__start_level mge-chapters">
                <div className="__img_sttas">
                  {((selectedTopic.notesStatus === 'teacher_review' && notTeacher) ||
                    (selectedTopic.notesStatus === 'review' && !isSE)) && (
                    <LightTooltip title={`Content Locked`} placement="right-end">
                      <button role="navigation" className="btn_svg_container">
                        <img src={AppPics.LockedContent} />
                      </button>
                    </LightTooltip>
                  )}{' '}
                  {(selectedTopic.notesStatus === 'teacher_review' && isTeacher) ||
                    (selectedTopic.notesStatus === 'review' && (isSE || !isTeacher) && (
                      <LightTooltip title={`Content Correction`} placement="right-end">
                        <button role="navigation" className="btn_svg_container">
                          <img src={AppPics.ContentCorrection} />
                        </button>
                      </LightTooltip>
                    ))}
                  {selectedTopic.notesStatus === 'teacher_verified' && (
                    <>
                      <LightTooltip title={`Content Verified`} placement="right-end">
                        <button role="navigation" className="btn_svg_container">
                          <img src={AppPics.ContentVerified} />
                        </button>
                      </LightTooltip>
                    </>
                  )}
                </div>
                {!editMode && (
                  <Link
                    className="lessonWrap__name"
                    to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}`}
                  >
                    <span ref={topicNameRef}>{topicName}</span>
                    {selectedTopic.notesStatus === 'teacher_review' && (
                      <span class="badge badge-danger vetting-cases teacher-vetting">
                        <img src={AppPics.TutorVettingEyeSVG} alt="" />
                        {underTutorReview}
                      </span>
                    )}
                    {selectedTopic.notesStatus === 'review' && (
                      <span class="badge badge-danger vetting-cases se-vetting">
                        <img src={AppPics.SubjectExpertVettingEyePNG} alt="" />
                        {underSeReview}
                      </span>
                    )}
                    {/* {selectedTopic.notesStatus === 'teacher_review' && (
                      <MdPermScanWifi title="Under review" color="red" />
                    )} */}
                  </Link>
                )}
                {editMode && (
                  <input
                    type="text"
                    value={topicName}
                    onChange={(event) => setTopicName(event.target.value)}
                  />
                )}
                {!editMode && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Edit"
                    disabled={chapter.isInTeacherReview}
                    onClick={() => {
                      if (chapter.isInTeacherReview) return;

                      setEditMode(!editMode);
                    }}
                  >
                    <img src={AppPics.EditSvg} alt="" />
                  </AppButton>
                )}
                {editMode && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Save"
                    disabled={chapter.isInTeacherReview}
                    onClick={manageTopic}
                  >
                    <img src={AppPics.CheckSvg} alt="" />
                  </AppButton>
                )}
                {true && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Copy"
                    disabled={chapter.isInTeacherReview}
                    onClick={() => {
                      if (chapter.isInTeacherReview) return;

                      setChapterCopyMode({
                        open: true,
                        data: { chapterID, topicID, classID, isCopy: true },
                      });
                    }}
                  >
                    <img src={AppPics.CopySvg} alt="Lesson/Topic Copy" />
                  </AppButton>
                )}
                <AppButton
                  variantClass="lessonWrap__btn"
                  title="Download PDF"
                  onClick={() => exportLessonPdf(usedTopicName || topicName, topicID, chapterID)}
                >
                  <MdPictureAsPdf
                    style={{
                      color: '#7e1f8c',
                      fontSize: '22px',
                      verticalAlign: 'middle',
                    }}
                  />
                </AppButton>
                <AppButton
                  variantClass="lessonWrap__btn"
                  title="Clone"
                  disabled={chapter.isInTeacherReview}
                  onClick={handleClone}
                >
                  <img src={AppPics.StampSvg} alt="" />
                </AppButton>
                {/* <AppButton variantClass="lessonWrap__btn">
                <img src={AppPics.ViewStrikeSvg} alt="" />
              </AppButton> */}
                <AppButton
                  variantClass="lessonWrap__btn"
                  title="Delete"
                  disabled={chapter.isInTeacherReview}
                  onClick={() => {
                    if (chapter.isInTeacherReview) return;

                    handleDeleteSModal({ show: true, data: { _id: topicID } });
                  }}
                >
                  <img src={AppPics.TrashBinSvg} alt="" />
                </AppButton>

                {/* <Link
                  to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}`}
                >
                  <AppButton variantClass="lessonWrap__btn" title="Go to">
                    <img src={AppPics.LinkSvg} alt="" />
                  </AppButton>
                </Link> */}
              </div>
            )}
            {!topicID && (
              <>
                <AppTextField
                  labelProps={{ label: 'Lesson Name' }}
                  inputProps={{
                    placeholder: 'Add lesson name here...',
                    value: topicName,
                    onChange: (event) => setTopicName(event.target.value),
                  }}
                />
                <AppButton variantClass="btn-plane p--tint m-l-btn my-4" onClick={manageTopic}>
                  Save
                </AppButton>
              </>
            )}
          </div>
          {/* BEGIN: LOOP SUB LESSONS HERE */}
          <ReactSortable
            list={subTopics}
            setList={(newState) => sortSubLessons(newState, topicID)}
            handle=".subtopicGrabHandleID"
            onSort={userPermissions?.subLesson?.canSortSubLesson && handleSubTopicSort}
          >
            {subTopics?.map((subTopic) => {
              return (
                <ManageSubLesson
                  key={subTopic._id}
                  subTopic={subTopic}
                  data={{
                    __chapterCloneState: [chapterCopyMode, setChapterCopyMode],
                  }}
                  classID={classID}
                  courseID={courseID}
                  chapterID={chapterID}
                  topicID={topicID}
                />
              );
            })}
          </ReactSortable>
          {/* END: LOOP SUB LESSONS HERE */}

          {/* BEGIN: ADD SUB LESSON INPUT HERE */}
          {addSubTopicView && (
            <div className="row mt-4">
              <div className="offset-1 col-11">
                <div className="lessonWrap lessonWrap--border formfield">
                  <AppTextField
                    labelProps={{ label: 'Sub Lesson Name' }}
                    inputProps={{
                      placeholder: userPermissions?.subLesson?.canAddSubLesson
                        ? 'Add sub lesson name here...'
                        : 'You dont have sufficient permission to add a sub lesson',
                      value: subTopicName,
                      onChange: (event) =>
                        userPermissions?.subLesson?.canAddSubLesson &&
                        setSubTopicName(event.target.value),
                    }}
                  />
                </div>
                <AppButton
                  disabled={!userPermissions?.subLesson?.canAddSubLesson}
                  variantClass="btn-plane p--tint m-l-btn my-4"
                  onClick={() => userPermissions?.subLesson?.canAddSubLesson && manageSubTopic()}
                >
                  Save sub lesson
                </AppButton>
              </div>
            </div>
          )}
          {/* END: ADD SUB LESSON INPUT HERE */}
        </div>
        <div
          className={`col-md-2 col-lg-2 col-sm-12 ${
            subTopics?.length === 0 ? `_pcetnteefid` : `cntrFlx`
          }`}
        >
          <AppButton
            variantClass="btn-plane p--tint"
            disabled={!userPermissions?.subLesson?.canAddSubLesson || chapter.isInTeacherReview}
            onClick={() => {
              if (chapter.isInTeacherReview) return;

              userPermissions?.subLesson?.canAddSubLesson && setAddSubTopicView(true);
            }}
          >
            ++ SUB LESSON
          </AppButton>
        </div>
      </div>
    </>
  );
}

function ManageSubLesson({ subTopic, classID, courseID, chapterID, topicID, data = {} }) {
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const { privateFetch } = useContext(FetchContext);
  const [editMode, setEditMode] = useState(false);
  const [subTopicName, setSubTopicName] = useState(false);
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const { __chapterCloneState } = data;
  const [chapterCopyMode, setChapterCopyMode] = __chapterCloneState;
  const { addJob } = usePdfJob();
  const subTopicNameRef = useRef(null);

  const { mutate, isLoading } = useManageSubTopics({ classID, courseID, chapterID, topicID });
  const { mutate: cloneSubTopic, isLoading: isCloning } = useCloneSubTopic({
    classID,
    chapterID,
    topicID,
  });

  useEffect(() => {
    setSubTopicName(subTopic.name || '');
  }, [subTopic.name]);

  useEffect(() => {
    if (!editMode) typesetMath(subTopicNameRef.current);
  }, [subTopicName, editMode]);

  function save() {
    if (isLoading) return;
    if (!subTopicName) return;

    const data = { name: `${subTopicName}`.trim() };
    mutate({
      type: 'UPDATE',
      ...data,
      subTopicID: subTopic._id,
    });
    setEditMode(!editMode);
  }

  function duplicateSubTopic(subtopics = []) {
    if (isCloning) return;

    cloneSubTopic({ subtopics });
  }

  function deleteSubTopic(subTopicID) {
    if (isLoading) return;

    mutate({ type: 'DELETE', subTopicID });
  }
  const { key } = userInfo?.data ?? {};
  const isSE = key === ROLES.SUBJECT_EXPERT;
  const notTeacher = key !== ROLES.TUTOR;
  const isTeacher = key === ROLES.TUTOR;
  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={() => handleDeleteSModal({ show: false, data: {} })}
        Header="Delete Sub Lesson"
        Body="Do you want to delete this sub lesson?"
        handleConfirmation={() => {
          deleteSubTopic(deleteSModal?.data?._id);
          handleDeleteSModal({ show: false, data: {} });
        }}
      />
      <div className="row mt-4" id={`${subTopic._id}`}>
        <div className="offset-1 col-11">
          <div className="lessonWrap lessonWrap--border saved subtopicGrabHandleID __subtopic_level">
            <div className="lessonWrap__text subLvsl">
              <div className="__img_sttas">
                {((subTopic.notesStatus === 'teacher_review' && notTeacher) ||
                  (subTopic.notesStatus === 'review' && isTeacher)) && (
                  <LightTooltip title={`Content Locked`} placement="right-end">
                    <button role="navigation" className="btn_svg_container">
                      <img src={AppPics.LockedContent} />
                    </button>
                  </LightTooltip>
                )}{' '}
                {((subTopic.notesStatus === 'teacher_review' && isTeacher) ||
                  (subTopic.notesStatus === 'review' && isSE)) && (
                  <LightTooltip title={`Content Correction`} placement="right-end">
                    <button role="navigation" className="btn_svg_container">
                      <img src={AppPics.ContentCorrection} />
                    </button>
                  </LightTooltip>
                )}
                {subTopic.notesStatus === 'teacher_verified' && (
                  <>
                    <LightTooltip title={`Content Verified`} placement="right-end">
                      <button role="navigation" className="btn_svg_container">
                        <img src={AppPics.ContentVerified} />
                      </button>
                    </LightTooltip>
                  </>
                )}
              </div>
              {!editMode && (
                <Link
                  className="lessonWrap__name"
                  to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}?subtopic=${subTopic._id}`}
                >
                  <span ref={subTopicNameRef}>{subTopicName}</span>
                  {subTopic.notesStatus === 'teacher_review' && (
                    <span class="badge badge-danger vetting-cases teacher-vetting">
                      <img src={AppPics.TutorVettingEyeSVG} alt="" />
                      {underTutorReview}
                    </span>
                  )}
                  {subTopic.notesStatus === 'review' && (
                    <span class="badge badge-danger vetting-cases se-vetting">
                      <img src={AppPics.SubjectExpertVettingEyePNG} alt="" />
                      {underSeReview}
                    </span>
                  )}
                </Link>
              )}
              {editMode && (
                <input
                  type="text"
                  value={subTopicName}
                  onChange={(event) => setSubTopicName(event.target.value)}
                />
              )}
              {!editMode && (
                <AppButton
                  variantClass="lessonWrap__btn"
                  onClick={() => setEditMode(!editMode)}
                  title="Edit"
                >
                  <img src={AppPics.EditSvg} alt="" />
                </AppButton>
              )}
              {editMode && (
                <AppButton variantClass="lessonWrap__btn" onClick={save} title="Save">
                  <img src={AppPics.CheckSvg} alt="" />
                </AppButton>
              )}
              {true && (
                <AppButton
                  variantClass="lessonWrap__btn"
                  title="Copy"
                  onClick={() => {
                    setChapterCopyMode({
                      open: true,
                      data: {
                        classID,
                        courseID,
                        chapterID,
                        topicID,
                        subTopicID: subTopic._id,
                        isCopy: true,
                      },
                    });
                  }}
                >
                  <img src={AppPics.CopySvg} alt="" />
                </AppButton>
              )}

              <AppButton
                variantClass="lessonWrap__btn"
                title="Clone"
                onClick={() => duplicateSubTopic([subTopic._id])}
              >
                <img src={AppPics.StampSvg} alt="" />
              </AppButton>

              {/* <button className="lessonWrap__btn">
                <img src={AppPics.ViewStrikeSvg} alt="" />
              </button> */}
              <AppButton
                variantClass="lessonWrap__btn"
                title="Delete"
                onClick={() => handleDeleteSModal({ show: true, data: { _id: subTopic._id } })}
              >
                <img src={AppPics.TrashBinSvg} alt="" />
              </AppButton>
              {/* <Link
                to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}?subtopic=${subTopic._id}`}
              >
                <AppButton variantClass="lessonWrap__btn" title="Go to">
                  <img src={AppPics.LinkSvg} alt="" />
                </AppButton>
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainChapters;
